import { type Workspace } from '@air/api/types';

import { SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY } from '../constants/sysadminLocalStorage';

type BasicWorkspaceInfo = Pick<Workspace, 'id' | 'name'>;

const readRecentlyUsed = (): BasicWorkspaceInfo[] => {
  const recentlyUsedString = localStorage.getItem(SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY);

  return recentlyUsedString ? JSON.parse(recentlyUsedString) : [];
};

export const promoteAdminWorkspace = (workspace: BasicWorkspaceInfo): void => {
  const recent = readRecentlyUsed();
  const rest = recent.filter((entry) => entry.id !== workspace.id);
  localStorage.setItem(SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY, JSON.stringify([workspace, ...rest]));
};
